export default {
    'auth':{
        'login':'/manage/auth/login',
        'logout':'/manage/auth/logout',
        'csrf':'/manage/refreshcsrftoken',
        'checkuser':'/manage/auth/checkuser',
    },
}
